<template>
  <div class="mc-modal mc-modal--h100" id="availabilityInStores" :class="{isOpen: isOpen}">
    <div class="mc-modal__outer">
      <div class="mc-modal__inner">
        <div class="mc-modal__heading">
          <button @click="$emit('close')" class="mc-modal__close-button js-button-close simulated-hover" type="button" aria-label="Закрыть">
            <svg class="mc-modal__close-icon" width="30" height="30" viewBox="0 0 30 30">
              <use xlink:href="/assets/svg/sprite.svg#icon-cross"></use>
            </svg>
          </button>
          <div class="mc-modal__title">
            Наличие в магазинах
          </div>
        </div>
        <div class="mc-modal__body">
          <div class="mc-availability">
            <section class="mc-availability__tabs mc-tabs mc-tabs--fr">
              <div class="mc-tabs__button-wrapper">
                <ul class="mc-tabs__list">
                  <li @click="tabShow = 1" class="mc-tabs__item" :class="{isActive: tabShow == 1}" id="tab1">
                    <button class="mc-tabs__button js-button-tab" data-name="content1" type="button">
                      На карте
                    </button>
                  </li>
                  <li @click="tabShow = 2" class="mc-tabs__item" :class="{isActive: tabShow == 2}" id="tab2">
                    <button class="mc-tabs__button js-button-tab" data-name="content2" type="button">
                      Списком
                    </button>
                  </li>
                  <li class="mc-tabs__glide" :style="tabGlide"></li>
                </ul>
              </div>
              <div class="mc-tabs__static">
                <div class="mc-select">
                  <button @click="showModalCity=true" class="mc-select__button js-modal-button" data-target="availabilityCity" type="button">
                    {{ map[city].name }}
                  </button>
                </div>
              </div>
              <div class="mc-tabs__body-wrapper">
                <div class="mc-tabs__body" :class="{isActive: tabShow == 1}" id="content1">
                  <yandex-map class="mc-availability__map"
                              :settings="{location: {        center: map[city].coordinates,        zoom: 10,      },    }"
                              width="100%"
                              height="500px"
                  >
                    <yandex-map-default-scheme-layer/>
                    <yandex-map-default-features-layer/>
                    <template v-if="productStoreLoaded">
                      <template v-for="item in productStore.STORE">
                        <yandex-map-default-marker :settings="{ coordinates: [item.gps_s, item.gps_n], onClick: () => { } }"></yandex-map-default-marker>
                      </template>
                    </template>
                  </yandex-map>
                </div>
                <div class="mc-tabs__body" :class="{isActive: tabShow == 2}" id="content2">
                  <ul class="mc-availability__list" v-if="productStoreLoaded && productStore.STORE.length > 0">
                    <template v-for="item in productStore.STORE">
                    <li class="mc-availability__item mc-availability-card" v-if="item.city == map[city].name">
                      <div class="mc-availability-card__title">
                        {{ item.name }}
                      </div>
                      <ul class="mc-availability-card__info-list">
                        <li class="mc-availability-card__info-item">
                          {{ item.address }}
                        </li>
                        <li class="mc-availability-card__info-item">
                          {{ item.schedule }}
                        </li>
                        <li class="mc-availability-card__info-item">
                          Телефон: {{ item.phone }}
                        </li>
                      </ul>
                      <ul class="mc-availability-card__features-list">
                        <li class="mc-availability-card__features-item" v-if="item.primer">
                          <img class="mc-availability-card__features-icon" src="/assets/svg/icon-dress.svg" width="15" height="15" alt="">
                          Примерочная
                        </li>
                        <li class="mc-availability-card__features-item" v-if="item.card">
                          <img class="mc-availability-card__features-icon" src="/assets/svg/icon-cardholder.svg" width="15" height="15" alt="">
                          Возможность оплаты картой
                        </li>
                      </ul>
                      <div class="mc-availability-card__bottom">
                        В наличии: {{ item.amount }}
                      </div>
                    </li>
                    </template>
                  </ul>

                  <div v-if="productStoreLoaded && productStore.STORE_CITY[map[city].name].count == 0">В наличии только в интернет-магазине.</div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div :class="{isOpen: showModalCity}" class="mc-modal" id="availabilityCity">
    <div class="mc-modal__outer">
      <div class="mc-modal__inner">
        <div class="mc-modal__heading">
          <button @click="showModalCity = false" class="mc-modal__close-button js-button-close simulated-hover" type="button" aria-label="Закрыть">
            <svg class="mc-modal__close-icon" width="30" height="30" viewBox="0 0 30 30">
              <use xlink:href="/assets/svg/sprite.svg#icon-cross"></use>
            </svg>
          </button>
          <div class="mc-modal__title">
            Город
          </div>
        </div>
        <div class="mc-modal__body">
          <ul class="mc-filter__option-list mc-options">
            <li v-for="(item, key) in map" class="mc-options__item">
              <button @click="city=key; showModalCity = false" class="mc-options__button" :class="{isSelected: city==key}" type="button">
                {{ item.name }}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
  YandexMap,
  YandexMapDefaultSchemeLayer,
  YandexMapDefaultFeaturesLayer,
  YandexMapDefaultMarker,
} from 'vue-yandex-maps';
export default {
  props: {
    isOpen: false,
    id: false
  },
  data:() => ({
    map: [
      {
        name: 'Санкт-Петербург',
        coordinates: [30.333655, 59.961368]
      },
      {
        name: 'Москва',
        coordinates: [37.573856, 55.751574]
      }
    ],
    city: 0,
    showModalCity: false,
    tabShow: 1,
    tabGlide: {
      left: 0,
      top: 0,
      width: 0,
      height: 0
    },
  }),
  computed: {
    ...mapGetters([
      'productStore',
      'productStoreLoading',
      'productStoreError',
      'productStoreLoaded'
    ])
  },
  created() {
    if (this.$props.id)
    this.fetchProductStore(this.$props.id);
  },
  mounted() {
    setTimeout(() => {
      this.setTabActive(1);
    },1000)
  },
  watch: {
    tabShow(newValue, oldValue) {
      this.setTabActive(newValue);
    },
    id(newValue, oldValue) {
      /*if (newValue)
      this.fetchProductStore(newValue);*/
    }
  },
  emits: ['close'],
  methods: {
    ...mapActions([
      'fetchProductStore'
    ]),
    getPositionRelativeToParent(element) {
      var parent = element.parentElement;
      var parentRect = parent === null || parent === void 0 ? void 0 : parent.getBoundingClientRect();
      var elementRect = element.getBoundingClientRect();
      return {
        left: elementRect.left - parentRect.left,
        top: elementRect.top - parentRect.top
      };
    },
    setTabActive(newValue) {
      let tabItem = document.getElementById('tab'+newValue);
      let relativePosition = this.getPositionRelativeToParent(tabItem);
      this.tabGlide.left = relativePosition.left + "px";
      this.tabGlide.top = relativePosition.top + "px";
      this.tabGlide.width = tabItem.offsetWidth + "px";
      this.tabGlide.height = tabItem.offsetHeight + "px";
    }
  },
  components: {YandexMap,
    YandexMapDefaultSchemeLayer,
    YandexMapDefaultFeaturesLayer,
    YandexMapDefaultMarker}
}
</script>